<div class="fieldset content-area">
    <img src="images/workbuddy_full_logo.svg">
    <div class="description description-title">404</div>
    <div class="description description-title-small">Page not found</div>
    <div class="description">The page you're looking for doesn't exist or has been moved.</div>
    <div class="flex-auto actions">
        <button (click)="onGoHome()" class="btn btn-primary">Go to Home</button>
    </div>
</div>